'use es6';

import EmbeddedViralLink from 'viral-links-lib/embedded-viral-link/EmbeddedViralLink';
import getLangLocale from 'I18n/utils/getLangLocale';
import { Component } from 'react';
import { connect } from 'react-redux';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
function FreemiumLink({
  portalId,
  embedded
}) {
  const verticalPadding = embedded ? 'p-y-2' : 'p-y-3';
  const linkType = embedded ? `meetings-embedded` : `meetings`;
  const environment = enviro.isQa() ? 'qa' : 'prod';
  return /*#__PURE__*/_jsx("div", {
    className: `text-center date-picker-freemium-cta ${verticalPadding}`,
    children: /*#__PURE__*/_jsx(EmbeddedViralLink, {
      linkType: linkType,
      langOverride: getLangLocale(),
      additionalParams: {
        portalId,
        isExternalLink: embedded,
        environment
      }
    })
  });
}
class FreemiumBookingUpgradeLink extends Component {
  render() {
    const {
      embedded,
      portalId
    } = this.props;
    return /*#__PURE__*/_jsx(FreemiumLink, {
      embedded: embedded,
      portalId: portalId
    });
  }
}
export default connect(state => ({
  portalId: state.portalId
}))(FreemiumBookingUpgradeLink);